import { Component, Renderer2 } from '@angular/core';
import AOS from 'aos';
import 'aos/dist/aos.css';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'banan-website';
  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {

    AOS.init(
      { disable: 'mobile' },
      {startEvent: 'load',},
      {once: true},
      window.addEventListener('load', AOS.refresh));
      
   
   

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      if (isMobile) {
        this.renderer.addClass(document.body, 'disable-aos');
      }
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'disable-aos');
  }
  
}
